import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Wheat } from "lucide-react";

const Preloader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1800); // 1.8 seconds entrance
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="fixed inset-0 z-[999] bg-[#0a120d] flex flex-col items-center justify-center sn-grain"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="flex flex-col items-center"
          >
            <div className="w-20 h-20 rounded-full border border-[var(--sn-gold)] flex items-center justify-center mb-6 relative">
              <motion.div 
                animate={{ rotate: 360 }}
                transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
                className="absolute inset-0 border border-t-transparent border-l-transparent border-[var(--sn-gold)] rounded-full opacity-50"
              />
              <Wheat className="w-10 h-10 text-[var(--sn-gold)]" />
            </div>
            <motion.h1 
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
              className="font-display text-4xl text-[var(--sn-gold)]"
            >
              Santo Nhoque
            </motion.h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="font-serif-alt italic text-[var(--sn-cream-soft)]/60 text-sm mt-2"
            >
              Massas artesanais desde 2015
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
